import { AddressDetails } from '@vend/business-components/dist/components/AddressForm/types'
import { AddressTypes } from '@vend/business-components/dist/components/EditCustomerModal/DetailsTab/Address'
import { ApiCustomer } from '@vend/types/customer'
import isEmpty from 'lodash/isEmpty'
import { FulfilmentDetail } from '../../../../../../models/fulfilment'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { FEATURE_ENABLE_LRX_33701_STATE_VALIDATION } from '../../../../../../constants'
import {
  AMERICAN_STATES,
  AUSTRALIA_COUNTRY_CODE,
  AUSTRALIAN_STATES,
  CANADA_COUNTRY_CODE,
  CANADIAN_PROVINCES,
  US_COUNTRY_CODE,
  VD_COUNTRY_CODES,
} from '../../../../../../vend-ui/constants'

export const americanStatesMap = AMERICAN_STATES.map(state => {
  return { code: state.code.toUpperCase(), name: state.name.toUpperCase() }
})

export const canadianProvincesMap = CANADIAN_PROVINCES.map(province => {
  return {
    code: province.code.toUpperCase(),
    name: province.name.toUpperCase(),
  }
})

export const australianStatesMap = AUSTRALIAN_STATES.map(state => {
  return { code: state.code.toUpperCase(), name: state.name.toUpperCase() }
})

const findAmericanState = (state: string) => {
  const stateUpper = state.toUpperCase()
  return americanStatesMap.find(
    usState => usState.code === stateUpper || usState.name === stateUpper
  )
}

const findCanadianProvince = (province: string) => {
  const provinceUpper = province.toUpperCase()
  return canadianProvincesMap.find(
    caProvince =>
      caProvince.code === provinceUpper || caProvince.name === provinceUpper
  )
}

const findAustralianState = (state: string) => {
  const stateUpper = state.toUpperCase()
  return australianStatesMap.find(
    auState => auState.code === stateUpper || auState.name === stateUpper
  )
}

export const findStateOrProvince = (
  addressState: string,
  countryId: string
) => {
  const countryIdUpper = countryId.toUpperCase()
  if (countryIdUpper === US_COUNTRY_CODE) {
    return findAmericanState(addressState)
  }
  if (countryIdUpper === CANADA_COUNTRY_CODE) {
    return findCanadianProvince(addressState)
  }
  if (countryIdUpper === AUSTRALIA_COUNTRY_CODE) {
    return findAustralianState(addressState)
  }
}

export const getCountryName = (countryId: string): string => {
  if (!countryId) return ''
  return (
    VD_COUNTRY_CODES.find(country => country.code === countryId)?.name || ''
  )
}

export const getStateCode = (
  addressState: string,
  country_id: string
): string => {
  if (!getFeatureFromCache(FEATURE_ENABLE_LRX_33701_STATE_VALIDATION))
    return addressState

  return findStateOrProvince(addressState, country_id)?.code || addressState
}

export const isAllAddressFieldsEmpty = (
  addressDetails?: AddressDetails
): boolean => {
  if (isEmpty(addressDetails)) return true

  return (
    addressDetails?.address_1 === '' &&
    addressDetails?.address_2 === '' &&
    addressDetails?.city === '' &&
    addressDetails?.postcode === '' &&
    addressDetails?.state === '' &&
    addressDetails?.suburb === ''
  )
}

export const getCustomerAddressDetails = (
  customer: ApiCustomer,
  addressType: AddressTypes
): AddressDetails => {
  return {
    address_1: customer[`${addressType}_address_1`] || '',
    address_2: customer[`${addressType}_address_2`] || '',
    suburb: customer[`${addressType}_suburb`] || '',
    city: customer[`${addressType}_city`] || '',
    state: customer[`${addressType}_state`] || '',
    country_id: customer[`${addressType}_country_id`] || '',
    postcode: customer[`${addressType}_postcode`] || '',
  }
}

export const generateAddressDetailsFromCustomer = (customer: ApiCustomer) => {
  const shipping = getCustomerAddressDetails(customer, AddressTypes.Shipping)
  const billing = getCustomerAddressDetails(customer, AddressTypes.Billing)

  const result: Partial<FulfilmentDetail> = {}
  if (!isAllAddressFieldsEmpty(shipping)) {
    result.shippingAddress = shipping
  }
  if (!isAllAddressFieldsEmpty(billing)) {
    result.billingAddress = billing
  }
  return result
}

export const fillEmptyAddressWithCustomerAddress = (
  customer: ApiCustomer,
  billingAddress?: AddressDetails,
  shippingAddress?: AddressDetails
) => {
  return {
    billingAddress:
      billingAddress ||
      getCustomerAddressDetails(customer, AddressTypes.Billing),
    shippingAddress:
      shippingAddress ||
      getCustomerAddressDetails(customer, AddressTypes.Shipping),
  }
}
